import FormActions from '../../logic/form-actions';
import FormType from '../../constants/form-type';

import LoginComponent from '../login-component';
import LoginFormHeader from '../form-components/form-header';
import EmailInput from '../form-components/email-input';

import {localize} from '../../infrastructure/localization';

import './forgot-password.scss';

export default class ForgotPassword extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <form className="forms-forgot-password" noValidate="true" onSubmit={
                (e) => {
                    e.preventDefault();
                    FormActions.forgotPassword(this.state.componentId);
                }
            }>
                <LoginFormHeader componentId={this.state.componentId} title={localize('forms.forgot-password.title')} />

                <div className="login-form-content">
                    <div className="instruction-placeholder">
                        <span>{localize('forms.forgot-password.instruction')}</span>
                    </div>

                    <EmailInput componentId={this.state.componentId} />

                    <div className="btn-submit-placeholder">
                        <button onClick={
                            () => {
                                FormActions.forgotPassword(this.state.componentId);
                            }
                        }
                                className="btn btn-submit">
                            {localize('forms.forgot-password.submit')}
                        </button>
                    </div>

                    <div className="btn-cancel-placeholder">
                        <button onClick={
                            () => {
                                FormActions.changeFormType(this.state.componentId, FormType.login);
                            }
                        }
                                className="btn btn-cancel">
                            {localize('forms.forgot-password.cancel')}
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/forms/forgot-password.jsx
 **/